import React from "react";
import _get from "lodash-es/get";
import _toArray from "lodash-es/toArray";
import { CAPTION_CHARACTER_LIMIT } from "../../../Helpers/Constants";
import { setCaretPosition, removeMoreNumberChar } from "../../../Helpers/Chat/ContentEditableEle";
import ContentEditable from '../ConversationSection/Conversation/Templates/Common/ContentEditable';

const Caption = (props = {}) => {
  const { onChangeCaption, media = {}, onClickSend } = props;
  const { caption = "" } = media;
  const [typingMessage, setTypingMessage] = React.useState({
    value: ""
  });
  const [selectedText, setSelectedTextState] = React.useState(null);
  const [position, setPosition] = React.useState(0);
  /**
  // const setCursorPosition = (pos) => setPosition(pos);
  */

  //cursor point set
  const setCursorPosition = (pos = 0) => {
    console.log(selectedText,position,"position")
    const { value: typeingValue = "" } = typingMessage;
    if (typeingValue) {
      const valueLength = typeingValue.length;//get typing length
      setCaretPosition(document.getElementById("image-preview-typingContainer"), +valueLength);
      setPosition(pos);
      let typingMessage = valueLength.length-1;
      if(typingMessage >= 0){valueLength.deleteData(typingMessage,0)}
    } else {
      setPosition(pos);
    }
  }

  /**
  // const handleEmojiText = (emojiObject) => {
  //   const { value: typeVal } = typingMessage;
  //   let positionToUpdate = position;
  //   let text = "";
  //   // When user select all the text & choose emoji means,
  //   // Need to replace the emoji with existing content.
  //   // That's why below we check condition, selectedText & current state typingMessage is equal
  //   // Need to clear other content message & enter only the emoji
  //   if (selectedText === typeVal) {
  //     text = emojiObject;
  //     positionToUpdate = emojiObject.length;
  //   } else {
  //     const start = typeVal.substring(0, position);
  //     const end = typeVal.substring(position);
  //     text = start + emojiObject + end;
  //     positionToUpdate = position + emojiObject.length;
  //   }
  //   if (_toArray(text).length <= CAPTION_CHARACTER_LIMIT) {
  //     setTypingMessage((prevState) => {
  //       setCursorPosition(positionToUpdate);
  //       setCaretPosition(document.getElementById("image-preview-typingContainer"), positionToUpdate);
  //       return {
  //         ...prevState,
  //         value: text
  //       };
  //     });
  //     onChangeCaption(media, text);
  //   }
  // };
  */

  // Added to Restrict User to Enter More than Allowed Characters Length
  const handleOnKeyDownListner = (e) => {    
    if (_toArray(_get(typingMessage, "value", "")).length >= CAPTION_CHARACTER_LIMIT){
      // if(!window.event.ctrlKey && e.which !== 8 
      if(!window.KeyboardEvent.ctrlKey && e.which !== 8 
        && e.which !== 46 
          && e.which !== 37 
            && e.which !== 38 
              && e.which !== 39 
                && e.which !== 40
                  && e.which !== 33 
                    && e.which !== 34)
      {
        e.preventDefault();
      }
    }
  }
  const handleMessage = ({ target }) => {
    const { value: targetVal } = target;
    setTypingMessage((prevState) => ({
      ...prevState,
      value:
        (prevState.value.length === 0 && targetVal.trim().length === 0) ||
          (targetVal.length === 1 && targetVal === "\n")
          ? ""
          : targetVal
    }));
    onChangeCaption(media, targetVal);
  };

  const remainingLenthCall = (typingMessageLength = 0) => {
    if (typingMessageLength >= 975) {
      const balanceCount = CAPTION_CHARACTER_LIMIT - typingMessageLength;
      return <span className="captionCount">{balanceCount > 0 ? balanceCount : 0}</span>;
    }
    return "";
  };

  const inputListenerHandler = () => true;
  const handleOnFocus = () => true;
  const setSelectedText = (selectText) => setSelectedTextState(selectText);

  React.useEffect(() => {
    handleMessage({ target: { value: caption } }); //captionValue has been set
  }, [caption]);

  const { value = "" } = typingMessage;

  return (
    <div className="uploadImageCaption" id="uploadImageCaption">
      <div className="message-area-container">
        <div className="message-area" id={`video-caption-${props?.uniqueId}`}>
          {/* <WebChatEmoji onEmojiClick={handleEmojiText} /> */}
          <ContentEditable
            captionCount={true}
            captionLength={value}
            id="image-preview-typingContainer"
            handleMessage={handleMessage}
            handleSendTextMsg={onClickSend}
            onInputListener={inputListenerHandler}
            handleOnFocus={handleOnFocus}
            placeholder={"Add a caption"}
            setCursorPosition={setCursorPosition}
            setSelectedText={setSelectedText}
            onKeyDownListner={handleOnKeyDownListner}
            html={removeMoreNumberChar(CAPTION_CHARACTER_LIMIT, value)}
          />
          {remainingLenthCall(_toArray(_get(typingMessage, "value", "")).length)}
        </div>
      </div>
    </div>
  );
};

export default Caption;
